<template>
  <div class="jc-bw-container">
    <div class="jc-page-top">
      <div class="jc-page-header">
        <h1>
          <i class="jc-icon-my-circle-bold"></i>{{$t('bandWidth.bd')}}
        </h1>
        <div class="jc-box-action">
          <a v-bind:href="Config.BANDWIDTH_SERVER_URL"
             target="_blank">{{$t('bandWidth.helpDoc',[$t('bandWidth.bd')])}}</a>
        </div>
      </div>
      <div class="jc-page-content">
        <!-- SearchListPane组件 -->
        <SearchListPane
          ref="searchPane"
          :search-configs="searchConfigs"
          :search-form-data="searchForm"
          @search="handleSearch"
          @reset="handleReset"
          :default-visible-count="3"
          :show-collapse-button="true"
        />
        <div class="el-container-table common-table-container">
          <!-- 表头操作 -->
          <div class="el-container-table-actionBar">
            <el-form class="el-box-table-search"
                     :inline="true"
                     @submit.native.prevent>
              <!-- <el-form-item>
                <el-select id="my-select"
                           v-model="searchKey"
                           @change="handleSearchChange"
                           class="search-select-width"
                           style="width:162px">
                  <el-option class="my-select-input"
                             v-for="item in searchParams"
                             :key="item.searchKey"
                             :label="item.searchLabel"
                             :value="item.searchKey"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-input :placeholder="searchPlaceholder[searchKey]"
                          v-model="searchValue"
                          @keyup.enter.native="handleSearch()"
                          class="my-input" clearable @clear="handleSearch()">
                  <el-button slot="append"
                             @click="handleSearch()"
                             icon="el-icon-search"
                             class="search-icon"></el-button>
                </el-input>
              </el-form-item> -->
              <!-- tag -->
                <el-form-item class="set-icon">
                  <jcb-tag-filter :service-code="ServiceCodeConstant.CCS"
                                  :visible.sync="batchEditTagDialogVisible"
                                  :region-id="TagRegionID"
                                  @checkedTags="filterWithCheckedTags">
                  </jcb-tag-filter>
                </el-form-item>
              <el-form-item class="set-icon">
                <el-button icon="el-icon-setting"
                           class="el-button-icon"
                           @click="setCustom()"
                           :title="$t('merge.customList')"></el-button>
              </el-form-item>
              <el-form-item>
                <el-button icon="jc-icon-download"
                           class="el-button-icon"
                           @click="exportList()"
                           :title="$t('speechcraft.exportResourceList')"></el-button>
              </el-form-item>
            </el-form>
            <el-form class="el-table-actionBar-item"
                     :inline="true">
              <el-form-item>
                <el-button icon="jc-icon-refresh-line"
                           class="el-button-icon"
                           @click="updateList"
                           ></el-button>
              </el-form-item>
              <el-form-item>
                <!-- <el-radio-group v-model="selectedRegion" @change="selectRegion">
                    <el-radio-group-advance :max-shown-count="5" more-trigger="click" :more-label="$t('text.moreNode')">
                      <el-radio-button v-for="room in fliter_region"
                                    :key="room.idcId"
                                    :label="room.idcId"
                        >{{ room.region }}</el-radio-button
                      >
                    </el-radio-group-advance>
                  </el-radio-group> -->
                  <!-- <el-select v-model="selectedRegion" @change="selectRegion" :placeholder="$t('placeholder.choose')">
                    <el-option
                      :key="AllId"
                      :value="AllId"
                      :label="$t('ticket.complete')">
                    </el-option>
                    <el-option
                      v-for="room in fliter_region"
                      :key="room.idcId"
                      :value="room.idcId"
                      :label="room.region">
                    </el-option>
                  </el-select> -->
              </el-form-item>
            </el-form>
          </div>
          <!-- 表格 -->
          <div class="el-container-table">
            <el-table :data="bandWidthList"
                      style="width: 100%"
                      ref="table"
                      v-loading="refreshloading"
                      :empty-text="tableEmptyTip"
                      @selection-change="handleSelectionChange"
                      @filter-change="changeFilter">
              <!-- 勾选 -->
              <el-table-column
                  type="selection"
                  width="55"
                  v-if="customInfo !== null">
                </el-table-column>
              <!-- ID -->
              <el-table-column prop="bandwidthId"
                                 key="bandwidthId"
                                 min-width="130"
                                 :label="$t('text.id')"
                                 v-if="getCustomInfoSelect('bandwidthId')"
                                 fixed>
                  <template slot-scope="scope">
                    <a href="javascript:void(0)"
                       @click="showDetail(scope.row)"
                       class="a-link-text">{{scope.row.bandwidthId}}</a>
                  </template>
                </el-table-column>
              <!-- 带宽（出口）名称 -->
              <el-table-column key="bandwidthName"
                               prop="bandwidthName"
                               min-width="160"
                               :label="$t('bandWidth.name')"
                               v-if="getCustomInfoSelect('bandwidthName')"
                               fixed>
                <template slot-scope="scope">
                  <a href="javascript:void(0)"
                     @click="showDetail(scope.row)">{{scope.row.bandwidthName}}</a>
                </template>
              </el-table-column>
              <!-- 机房名称 -->
              <el-table-column prop="datacenterNameShow"
                key="datacenterNameShow"
                min-width="200"
                :label="$t('cabinet.roomName')"
                v-if="getCustomInfoSelect('datacenterNameShow')"
                >
              </el-table-column>
              <!-- 机房名称 改为 托管区 -->
              <el-table-column prop="regionShow"
                key="regionShow"
                min-width="200"
                :label="$t('idcs.region')"
                v-if="getCustomInfoSelect('regionShow')">
              </el-table-column>
              <!-- 关联的公网IP -->
              <el-table-column key="relatedIpArr"
                               prop="relatedIpArr"
                                min-width="200"
                               :label="$t('speechcraft.relatedIP')"
                               v-if="getCustomInfoSelect('relatedIp')">
                <template slot-scope="scope">
                  <div>
                    <div v-for="(item,index) in scope.row.relatedIpArr"
                         :key="index"
                         v-if="index < 2">{{item.cidrAddr}}</div>
                      <el-popover
                        placement="left"
                        trigger="hover"
                        v-if="scope.row.relatedIpArr.length > 2">
                        <div>
                          <div v-for="(item, index) in scope.row.relatedIpArr" :key="index" v-if="index >= 2">
                            {{ item.cidrAddr }}
                          </div>
                        </div>
                        <div slot="reference" style="cursor: pointer;">...</div>
                      </el-popover>
                  </div>
                </template>
              </el-table-column>
              <!-- 线路类型 -->
              <el-table-column key="lineTypeName"
                               prop="lineTypeName"
                               columnKey="lineType"
                               min-width="100"
                               :label="$t('bandWidth.lineType')"
                               v-if="getCustomInfoSelect('lineTypeName')"
                               >
                <template slot-scope="scope">
                  <span v-if=" scope.row.lineTypeName !== ''">{{scope.row.lineTypeName}}</span>
                  <span v-else>--</span>
                </template>
              </el-table-column>
              <!-- 带宽 -->
              <el-table-column key="physicalBandwidth"
                               prop="physicalBandwidth"
                               min-width="120"
                               :label="$t('bandWidth.bandwidthName') + '（Mbps）'"
                               v-if="getCustomInfoSelect('physicalBandwidth')">
                <template slot-scope="scope">
                  <span v-if=" scope.row.physicalBandwidth !== null">{{scope.row.physicalBandwidth}}</span>
                  <span v-else>--</span>
                </template>
              </el-table-column>
              <!-- 计费方式 -->
              <el-table-column key="chargeTypeName"
                               prop="chargeTypeName"
                               columnKey="chargeType"
                                :label="$t('bandWidth.chargeType')"
                                min-width="300"
                               v-if="getCustomInfoSelect('chargeTypeName')">
                <template slot-scope="scope">
                  <!-- 固定带宽 -->
                  <div v-if="scope.row.chargeType && scope.row.chargeType === 'fixedBandwidth'">
                    <span>{{scope.row.chargeTypeName}}</span><br/>
                    <span>{{$t('bandWidth.contractBandwidth')}}（Mbps）：<span v-if="scope.row.bandwidth !== null">{{scope.row.bandwidth}}</span> <span v-else>--</span></span>
                  </div>
                  <!-- 两种95峰值：保底带宽 -->
                  <div v-else-if="scope.row.chargeType && scope.row.chargeType !== 'fixedBandwidth'">
                    <span>{{scope.row.chargeTypeName }}</span><br/>
                    <span>{{$t('bandWidth.minBandwidth')}}（Mbps）：<span v-if="scope.row.bandwidth !== null">{{scope.row.bandwidth}}</span> <span v-else>--</span></span>
                  </div>
                  <span v-else>--</span>
                </template>
              </el-table-column>
              <el-table-column :label="$t('cabinet.billingInfo')"
                                 prop="deviceOpenTime"
                                 min-width="160"
                                 v-if="getCustomInfoSelect('billingInfo')">
                <template slot-scope="scope">
                  <div>
                    <span>{{$t('cabinet.billingTime')}}: {{scope.row.startTime | maybeEmpty}}</span><br/>
                    <span>{{$t('cabinet.expireTime')}}: {{scope.row.endTime | maybeEmpty}}</span>
                  </div>
                </template>
              </el-table-column>
              <!--合同/保底带宽（Mbps）-->
              <!-- <el-table-column key="bandwidth"
                               prop="bandwidth"
                               min-width="120"
                               :label="$t('bandWidth.contractMinBandwidth') + '（Mbps）'"
                               v-if="customerInfo !== null && customerInfo['bandwidth'].selected">
                <template slot-scope="scope">
                  <span v-if=" scope.row.bandwidth != 0">{{scope.row.bandwidth}}</span>
                  <span v-else>--</span>
                </template>
              </el-table-column> -->
              <!-- 状态 -->
              <!-- <el-table-column key="status"
                               prop="status"
                               :label="$t('text.status')"
                               v-if="customerInfo !== null && customerInfo['status'].selected">
                <template slot-scope="scope">
                  <span :class="statusMap[scope.row.status]">{{filter_status[scope.row.status]}}</span>
                </template>
              </el-table-column> -->
              <!-- 标签 -->
              <el-table-column :label="$t('text.tags')"
                              key="tags"
                              v-if="getCustomInfoSelect('tags')"
                               min-width="120"
                              class-name="p-line-break">
                <template slot-scope="scope">
                  <p>{{scope.row.tagPairs | maybeEmpty}}</p>
                </template>
              </el-table-column>
              <!--操作-->
                <el-table-column key="operate"
                                    min-width="100"
                                 :label="$t('text.operate')">
                  <template slot-scope="scope">
                    <div style="display:flex">
                      <!-- <el-button type="text"
                                @click="clickOperateTag(scope.row)">
                        {{ $t('text.editTag') }}
                      </el-button> -->
                      <!-- 查看监控 -->
                      <el-button type="text" @click="goMonitor(scope.row)">
                        {{ $t('text.goMonitor') }}
                      </el-button>
                    </div>
                  </template>
                </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <div class="el-page-footer block el-container-table-actionBar"
         v-if="bandWidthList.length">
      <el-tooltip class="item" effect="dark" :content="$t('text.pleaseSelectResource')" :disabled="!!multipleSelection.length" :visible-arrow="false" placement="top">
        <el-button type="primary" class="margin-top-ten"  :disabled="!multipleSelection.length" @click="batchEditTag">{{$t('text.editTag')}}</el-button>
      </el-tooltip>
      <el-pagination @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page="currentPage"
                     :page-sizes="pageSizes"
                     :page-size="pageSize"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="totalItems">
      </el-pagination>
    </div>
    <custom :visible.sync="customVisible"
            v-if="customVisible"
            :optionArr="optionArr"
            :type="type"></custom>
    <jcb-tag-edit :visible.sync="editTagDialogVisible"
                  :service-code="ServiceCodeConstant.CCS"
                  :region-id="TagRegionID"
                  :resource-ids="resourceId"
                  @complete="updateList">
    </jcb-tag-edit>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash';
import custom from '../common/custom/Custom.vue';
import SearchListPane from '../common/search/SearchListPane.vue';
import { ServiceCodeConstant } from '@/common/Constants';
import { handleChangeAllSelectedValue, AllSelectOption, AllId, PlaceholderIdc } from '@/utils/common/index'
import searchOperate from '@/mixins/searchOperate'
import customInfoSelect from '@/mixins/customInfoSelect'

const type = 'bandwidth';

export default {
  components: { custom, SearchListPane },
  mixins: [searchOperate, customInfoSelect],
  name: 'bandwidth',
  data () {
    return {
      AllId,
      filtersValue: {
        lineType: [],
        chargeType: []
      },
      refreshloading: false,
      bandWidthList: [],
      searchValue: '',
      searchKey: 'bandwidthName',
      searchParams: [
        {
          searchKey: 'bandwidthName',
          searchLabel: this.$t('bandWidth.name')
        },
        {
          searchKey: 'relatedIp',
          searchLabel: this.$t('bandWidth.relationPublicNetIp')
        }
      ],
      searchPlaceholder: {
        bandwidthName: this.$t('bandWidth.inputName'),
        relatedIp: this.$t('bandWidth.inputIp')
      },
      statusMap: {
        'abnormal': 'jc-status jc-status--orange',
        'normal': 'jc-status jc-status--green'
      },
      filter_status: {
        normal: this.$t('text.normal'),
        abnormal: this.$t('text.abnormal'),
      },
      currentPage: 1,
      totalItems: 0,
      selectedRegion: AllId,
      regionMap: [],
      fliter_region: [],
      pageSize: 20,
      pageSizes: [20, 50, 100],
      type,
      customVisible: false,
      initFlag: false,
      tableEmptyTip: this.$t('text.noSearch'),
      optionArr: [
        {
          label: this.$t('text.id'),
          value: 'bandwidthId'
        },
        { label: this.$t('bandWidth.name'), value: 'bandwidthName' },
        {
          // 机房名称
          label: this.$t('cabinet.roomName'),
          value: 'datacenterNameShow'
        },
        {
          // 原 机房名称 改为 托管区
          label: this.$t('idcs.region'),
          value: 'regionShow'
        },
        { label: this.$t('bandWidth.relationPublicNetIp'), value: 'relatedIp' },
        { label: this.$t('bandWidth.lineType'), value: 'lineTypeName' },
        { label: this.$t('bandWidth.chargeType'), value: 'chargeTypeName' },
        { label: `${this.$t('bandWidth.bandwidthName')}（Mbps）`, value: 'physicalBandwidth' },
        // 计费信息
        {
          label: this.$t('cabinet.billingInfo'),
          value: 'billingInfo'
        },
        // { label: `${this.$t('bandWidth.contractMinBandwidth')}（Mbps）`, value: 'bandwidth' },
        // { label: this.$t('text.status'), value: 'status' },
        {
          // 标签
          label: this.$t('text.tags'),
          value: 'tags'
        }
        // {
        //   // 操作
        //   label: this.$t('text.operate'),
        //   value: 'operation'
        // }
      ],
      // 编辑标签组件是否显示
      editTagDialogVisible: false,
      // 批量编辑标签组件是否显示
      batchEditTagDialogVisible: true,
      resourceId: [],
      // 标签过滤后的资源ID
      filteredResourceIds: [],
      multipleSelection: [],

      // SearchListPane配置
      searchConfigs: [
        {
          field: 'bandwidthName',
          type: 'input',
          label: this.$t('bandWidth.name'),
          placeholder: this.$t('bandWidth.inputName')
        },
        {
          field: 'datacenterName',
          type: 'multiple-select',
          label: this.$t('cabinet.roomName'),
          placeholder: this.$t('placeholder.placeholderSelectMore', [this.$t('cabinet.roomName')]),
          options: []
        },
        {
          field: 'bandwidthId',
          type: 'input',
          label: this.$t('text.id'),
          placeholder: this.$t('placeholder.placeholderInput', [this.$t('text.id')]),
        },
        {
          field: 'regionEn',
          type: 'multiple-select',
          label: this.$t('create.text.az'),
          placeholder: this.$t('placeholder.placeholderSelectMore', [this.$t('create.text.az')]),
          options: []
        },
        {
          field: 'relatedIp',
          type: 'input',
          label: this.$t('bandWidth.relationPublicNetIp'),
          placeholder: this.$t('bandWidth.inputIp')
        },
        {
          field: 'lineType',
          type: 'multiple-select',
          label: this.$t('bandWidth.lineType'),
          placeholder: this.$t('placeholder.placeholderSelectMore', [this.$t('bandWidth.lineType')]),
          options: []
        },
        {
          field: 'chargeType',
          type: 'multiple-select',
          label: this.$t('bandWidth.chargeType'),
          placeholder: this.$t('placeholder.placeholderSelectMore', [this.$t('bandWidth.chargeType')]),
          options: []
        }
      ],
      searchForm: {
        bandwidthName: '', // 带宽名称
        datacenterName: [], // 机房名称
        bandwidthId: '', // ID
        regionEn: [], // 托管区
        relatedIp: '', // 关联公网IP
        lineType: [], // 线路类型
        chargeType: [] // 计费方式
      },
    };
  },
  created () {
    /*
    * 改变过滤方法
    * 可以在created里尝试调用一下
    * filterChange
    * 同样调用updateList */
    const query = this.$route.query;
    if (query.selectRoom !== undefined) {
      this.selectedRegion = query.selectRoom;
    }
    if (query.lineTypeConsole !== undefined) {
      this.filtersValue.lineType.push(query.lineTypeConsole);
    }
    this.getRegion();
    if (this.$store.state.customInfo[this.type] === null) {
      this.getCustomInfo();
    }
  },
  mounted () { },
  computed: {
    ServiceCodeConstant: () => ServiceCodeConstant,
    // vuex中获取自定义信息
    customInfo () {
      return this.$store.state.customInfo[this.type];
    },

    // vuex中获取bandwidth状态
    filterList () {
      return this.$store.state.filter.filterList;
    },

    needRequireResource () {
      return !!this.selectedRegion;
    }
  },
  methods: {
    batchEditTag() {
      this.resourceId = [];
      this.multipleSelection.forEach((item) => {
        this.resourceId.push(item.bandwidthId);
      });
      this.editTagDialogVisible = true;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    goMonitor(row) {
      const { bandwidthId, bandwidthName, regionEn } = row;
      this.$router.push({
        path: `/bandwidthtraffic/detail/${bandwidthId}`,
        query: { bandwidthName, tabName: 'monitor', idcId: regionEn }
      })
    },
    clickOperateTag (data) {
      this.resourceId = [].concat([data.bandwidthId]);
      this.editTagDialogVisible = true;
    },
    /**
     **@disc: 根据标签对实例进行过滤
     */
    filterWithCheckedTags(filterTags, tagKeys, resourceIds) {
      console.log(filterTags, tagKeys, resourceIds);
      if (tagKeys.length !== 0) {
        this.filteredResourceIds = resourceIds;
      } else {
        this.filteredResourceIds = [];
      }
      this.updateList();
    },
    // 获取区域信息
    getRegion () {
      this.$api.getRegions({ all: 1, idcLine: this.GLOBAL.IDCLINE }).then((res) => {
        if (res.errno === 10000 && res.errmsg === 'OK') {
          if (res.data && res.data.idcs.length > 0 && res.data.idcs[0] != null) {
            const data = res.data.idcs;
            this.regionFormat(data);
            // 更新搜索配置选项
            this.initSearchOptions();
            if (this.$route.query.selectRoom !== undefined) {
              this.$nextTick(() => {
                this.selectedRegion = this.$route.query.selectRoom;
              })
            } else if (res.data.idcs) {
              this.$nextTick(() => {
                // this.selectedRegion = res.data.idcs[0].idc;
                // 地区默认勾选"全部"
                this.selectedRegion = AllId
              })
            }
            this.$nextTick(() => {
              this.selectedRegion.length && this.selectRegion();
            })
          } else {
            this.fliter_region = [];
          }
        } else {
          this.$message.error(res.errmsg);
        }
      });
    },

    handleSearchChange () {
      this.searchValue = '';
    },

    // 获取自定义信息
    getCustomInfo () {
      const param = {
        pageKey: this.type
      };
      this.$api.getCustomInfo(param).then((res) => {
        if (res.errno === 10000 && res.data.customInfo) {
          this.$store.commit('GET_CUSTOMINFO', { value: res.data.customInfo, type: this.type });
        }
      });
    },

    regionFormat (data) {
      this.fliter_region = [];
      for (let i = 0; i < data.length; i++) {
        this.fliter_region.push({
          // idcId: data[i].idc,
          // region: data[i].idcName,
          datacenterNameParam: data[i].datacenterNameParam,
          datacenterNameShow: data[i].datacenterNameShow,
          regionShow: data[i].regionShow,
          regionEn: data[i].regionEn
        });
      }
      // 插入下拉原始“全部”选项
      // this.fliter_region.unshift(AllSelectOption(this, 'idcId', 'region'))
    },

    // 跳转详情
    showDetail (row) {
      const routeData = this.$router.resolve({
        path: '/bandwidth/detail',
        query: { id: row.bandwidthId, idcId: row.regionEn }
      });
      window.open(routeData.href, '_blank');
    },

    // 获取带宽列表
    getBandWidth (params) {
      if (!this.needRequireResource) {
        return;
      }
      // if (this.searchForm.datacenterName.length) {
      //   this.selectedRegion = this.searchForm.idc.join(',');
      // } else {
      //   this.selectedRegion = AllId;
      // }
      const dataParams = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        // idc: this.selectedRegion
      };
      let tempParams = params || dataParams;
      // 是否通过标签进行筛选
      if (this.filteredResourceIds.length) {
        tempParams.bandwidthId = this.filteredResourceIds.join(' ');
      }
      // 处理SearchListPane搜索参数
      for (const key in this.searchForm) {
        const value = this.searchForm[key];
        if (Array.isArray(value) && value.length > 0) {
          // 处理数组类型参数（多选下拉框）
          params[key] = value.join(',');
          this.tableEmptyTip = this.$t('text.hasSearch');
        } else if (typeof value === 'string' && value.trim() !== '') {
          // 处理字符串类型参数（输入框）
          params[key] = value;
          this.tableEmptyTip = this.$t('text.hasSearch');
        }
      }
      // 选择下拉筛选的“全部”all
      // tempParams = {...tempParams, ...handleChangeAllSelectedValue(this.selectedRegion)}
      this.refreshloading = true;
      this.$api.getBandWidthList(tempParams).then((res) => {
        if (res.errno === 10000 && res.errmsg === 'OK') {
          if (res.data && res.data.bandwidths.length > 0 && res.data.bandwidths[0] != null) {
            this.bandWidthList = cloneDeep(res.data.bandwidths);
            this.bandWidthList.forEach((item) => {
              item.tagPairs = '';
              if (item.tags !== undefined && item.tags.length > 0) {
                item.tags.forEach((tag) => {
                  item.tagPairs += `${tag.key}:${tag.value},`;
                });
                item.tagPairs = item.tagPairs.substring(0, item.tagPairs.length - 1);
              }
            });
            this.totalItems = res.data.totalCount;
            this.bandWidthListFormat(this.bandWidthList);
          } else {
            this.bandWidthList = [];
            this.totalItems = 0;
          }
        } else {
          this.$message.error(res.errmsg);
          this.bandWidthList = [];
          this.totalItems = 0;
        }
        this.initFlag = false;
      }).finally(() => {
        this.refreshloading = false;
        // this.filteredResourceIds = [];
      });
    },

    bandWidthListFormat (data) {
      for (let i = 0; i < data.length; i++) {
        data[i].relatedIpArr = data[i].relatedIp;
      }
    },

    // 更新SearchListPane配置选项
    initSearchOptions() {
      // 更新机房名称选项
      const idcNameOptions = this.fliter_region.length && (this.fliter_region || []).map(region => ({
        value: region.datacenterNameParam,
        label: region.datacenterNameShow
      }));

      // 更新托管区选项
      const idcOptions = this.fliter_region.length && (this.fliter_region || []).map(region => ({
        value: region.regionEn,
        label: region.regionShow
      }));

      // 更新 计费方式
      const chargeTypeOptions = (this.filterList && this.filterList.chargeType) ? [...this.filterList.chargeType] : [];
      // 更新线路类型选项
      const lineTypeOptions = (this.filterList && this.filterList.lineType) ? [...this.filterList.lineType] : [];

      // 更新searchConfigs中的选项
      this.searchConfigs = this.searchConfigs.map(config => {
        if (config.field === 'datacenterName') {
          return { ...config, options: idcNameOptions };
        }
        if (config.field === 'regionEn') {
          return { ...config, options: idcOptions };
        }
        if (config.field === 'chargeType') {
          return { ...config, options: chargeTypeOptions };
        }
        if (config.field === 'lineType') {
          return { ...config, options: lineTypeOptions };
        }
        return config;
      });
    },

    updateList (type) {
      if (!this.needRequireResource) {
        return;
      }
      // 切换区域清除条件刷新
      this.tableEmptyTip = this.$t('text.noSearch');
      if (type === 'refresh') {
        this.searchValue = '';
        this.initFlag = true;
        this.currentPage = 1;
        this.refreshloading = true;
        this.tableEmptyTip = this.$t('text.noSearch');
        this.$refs.table.clearFilter();
      }
      const params = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        // idc: this.selectedRegion,
        lineType: type !== 'all' ? this.$route.query.lineTypeConsole : ''
      };
      // 是否有模糊搜索
      if (this.searchValue.trim() != '' && this.searchKey != '') {
        this.tableEmptyTip = this.$t('text.hasSearch');
        params[this.searchKey] = this.searchValue;
      }
      if (this.selectedRegion && this.selectedRegion !== AllId && !this.searchForm.regionEn.length && !this.searchForm.datacenterName.length) {
        params.regionEn = this.selectedRegion;
      }

      // 处理搜索表单数据
      if (this.searchForm) {
        // 使用for...in循环处理搜索参数
        for (const key in this.searchForm) {
          const value = this.searchForm[key];
          if (Array.isArray(value) && value.length > 0) {
            // 处理数组类型参数（多选下拉框）
            params[key] = value.join(',');
          } else if (typeof value === 'string' && value.trim() !== '') {
            // 处理字符串类型参数（输入框）
            params[key] = value.trim();
          }
        }

        // 特殊处理：ID搜索（支持多个精确，单个模糊，空格分开）
        if (this.searchForm.bandwidthId && this.searchForm.bandwidthId.trim() !== '') {
          const bandwidthIds = this.searchForm.bandwidthId.trim().split(/\s+/);
          if (bandwidthIds.length > 1) {
            // 多个ID，精确搜索
            params.bandwidthId = bandwidthIds.join(',');
          }
        }

        // 特殊处理：带宽名称搜索时显示搜索提示
        if (this.searchForm.bandwidthName && this.searchForm.bandwidthName.trim() !== '') {
          this.tableEmptyTip = this.$t('text.hasSearch');
        }
      }

      Object.keys(this.filtersValue).forEach((key) => {
        if (this.filtersValue[key].length > 0) {
          params[key] = this.filtersValue[key][0];
        }
      });
      this.getBandWidth(params);
    },


    // 导出列表
    exportList () {
      if (!this.needRequireResource) {
        return;
      }
      let url = `/ccs-api/api/resource/exportBandwidths?all=1`;
      // 全选，导出列表参数拼接 ignoreIdc = 1
      // if (this.selectedRegion === AllId) {
      //   url = `/ccs-api/api/resource/exportBandwidths?ignoreIdc=1&idc=${PlaceholderIdc}&all=1`;
      // }
      // 是否有搜索
      if (this.searchValue != '' && this.searchKey != '') {
        url += `&${this.searchKey}=${this.searchValue}`;
      }
      Object.keys(this.filtersValue).forEach((key) => {
        if (this.filtersValue[key].length > 0) {
          url += `&${key}=${this.filtersValue[key][0]}`;
        }
      });
      if (this.selectedRegion && this.selectedRegion !== AllId && !this.searchForm.regionEn.length && !this.searchForm.datacenterName.length) {
        url += `&regionEn=${this.selectedRegion}`;
      }
      // 增加遍历搜索表单参数
      if (this.searchForm) {
        for (const key in this.searchForm) {
          const val = this.searchForm[key];
          if (val !== '' && val !== null && val !== undefined) {
            if (Array.isArray(val) && val.length === 0) {
              continue;
            }
            url += `&${key}=${val}`;
          }
        }
      }
      // 拼接 针对 filteredResourceIds 标签 过滤的入参
      if (this.filteredResourceIds.length) {
        url += `&bandwidthId=${this.filteredResourceIds.join(' ')}`;
      }
      console.log(url);
      window.open(url, '_self');
    },

    // 自定义
    setCustom () {
      this.customVisible = true;
    },

    handleSizeChange (val) {
      this.pageSize = val;
      this.updateList();
    },

    handleCurrentChange (val) {
      this.currentPage = val;
      if (!this.initFlag) {
        this.updateList();
      }
    },

    selectRegion () {
      Object.keys(this.filtersValue).forEach((key) => {
        this.filtersValue[key] = [];
      });
      if (this.fliter_region.length > 0) {
        this.updateList('refresh');
      }
    },

    filtersLineType (value, row) {
      return true;
    },
    filterschargeType() {
      return true;
    },
    // 根据状态搜索
    changeFilter (filter) {
      this.currentPage = 1;
      Object.keys(filter).forEach((key) => {
        this.filtersValue[key] = filter[key];
      });
      // if (filter.lineType.length == 0) {
      //   this.updateList('all');
      // } else {
      this.updateList();
      // }
    },
  }
};
</script>
<style lang="scss">
@import "./BandWidth.scss";
</style>
<style lang="scss" scoped>
.jc-bw-container /deep/ .custom-container .jc-dialog.jc-dialog--small {
  width: 500px;
}
</style>



// WEBPACK FOOTER //
// src/components/bandWidth/BandWidth.vue